export default "__VITE_ASSET__Dp68JIdi__"